import PropTypes from "prop-types";
import ReceiptIcon from "../../../assets/images/icons/catering-icons/receipt-icon.svg";
import ZapIcon from "../../../assets/images/icons/catering-icons/zap-icon.svg";
import GiftIcon from "../../../assets/images/icons/catering-icons/gift-icon.svg";
import { Link } from "react-router-dom";

export function StatCard({
  pointsEarned,
  dollarAmountEarned,
  pointsRedeemed,
  dollarAmountRedeemed,
}) {
  return (
    <div className="bg-white rounded-xl p-4 w-full max-w-md shadow-sm" style={{ height: "196px" }}>
      <div className="flex items-center mb-4 gap-3">
        <img className="w-[45px] h-[45px]" src={ZapIcon} />
        <span className="text-gray-800 font-medium text-base">Total points earned</span>
      </div>

      <div className="mb-[14px]">
        <h2 className="text-2xl font-semibold text-gray-900">
          {pointsEarned} <span className="text-[#475467]">{dollarAmountEarned}</span>
        </h2>
      </div>

      <div>
        <p className="text-[#535862] text-sm mb-1">Total points Redeemed</p>
        <p className="text-[#079455] text-sm font-medium">
          {pointsRedeemed} {dollarAmountRedeemed}
        </p>
      </div>
    </div>
  );
}

StatCard.propTypes = {
  pointsEarned: PropTypes.any,
  dollarAmountEarned: PropTypes.string,
  pointsRedeemed: PropTypes.string,
  dollarAmountRedeemed: PropTypes.string,
};

export function StatCardWithButton({
  onClick,
  subText,
  disabled,
  bottomText,
  btnText = "Upload Receipt",
  header = "Upload Receipts",
  icon,
}) {
  return (
    <div
      className="bg-white rounded-xl w-full max-w-md shadow-sm flex flex-col"
      style={{ height: "196px" }}
    >
      <div className="flex gap-3 items-center mb-4 px-4 pt-4">
        <img className="w-[45px] h-[45px]" src={icon ? GiftIcon : ReceiptIcon} />
        <span className="text-gray-800 font-medium text-base">{header}</span>
      </div>

      <div className="px-4 mb-4 flex-grow">
        {subText ? (
          subText
        ) : (
          <p className="text-[#535862] text-sm font-medium">
            Upload receipts to get started with rewards
          </p>
        )}
      </div>

      <div
        className={`border-t border-gray-100 flex ${
          bottomText ? "justify-between" : "justify-end"
        }  p-4 items-center mt-auto`}
      >
        {bottomText && (
          <div
            style={{
              fontSize: "0.9rem",
              fontStyle: 500,
            }}
          >
            Pending request:
            <span className="font-semibold"> ${bottomText}</span>
          </div>
        )}

        {onClick ? (
          <button
            disabled={disabled}
            onClick={onClick}
            className="bg-[#238856] disabled:opacity-70 hover:bg-[#238856]/90 rounded-lg outline-none border-none p-[8px_12px] flex items-center justify-center text-sm font-semibold text-white m-0"
            style={{ textTransform: "none", height: 36 }}
          >
            {btnText}
          </button>
        ) : (
          <Link
            to="/upload-receipts"
            disabled={disabled}
            onClick={onClick}
            className="bg-[#238856] disabled:opacity-70 hover:bg-[#238856]/90 rounded-lg outline-none border-none p-[8px_12px] flex items-center justify-center text-sm font-semibold text-white m-0"
            style={{ textTransform: "none", height: 36 }}
          >
            {btnText}
          </Link>
        )}
      </div>
    </div>
  );
}

StatCardWithButton.propTypes = {
  subText: PropTypes.string,
  onClick: PropTypes.any,
  disabled: PropTypes.bool,
  btnText: PropTypes.string,
  header: PropTypes.string,
  icon: PropTypes.bool,
  bottomText: PropTypes.any,
};
